import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../redux/store'
import { CcamCode } from '../models/CcamCode'

export const retrieveCcamCodes = createAsyncThunk<
  CcamCode[],
  { categoryLabel: string; search?: string },
  ThunkConfig
>(
  'simulation/retrieveCcamCodes',
  async ({ categoryLabel, search }, { extra }) => {
    const ccamCodes = await extra.simulationGateway.fetchCcamCodes(
      categoryLabel,
      search
    )
    return ccamCodes
  }
)
